module.exports = __webpack_public_path__ + "static/media/pin_brown_highlighted.72b568ca.png";